// extracted by mini-css-extract-plugin
export var alertIcon = "_ur-0";